import { jsx } from 'react/jsx-runtime';
import EmojiPicker$1, { Theme } from '../../node_modules/emoji-picker-react/dist/emoji-picker-react.esm.js';
import { styled } from 'styled-components';
import { useColorScheme } from '../theme/useColorScheme.js';
import { cssVar } from '../theme/variables.js';
import { useEmojiSkinTone } from '@fabric-app/compat/capabilities/ui';

const defaultProps = {
  theme: Theme.AUTO,
  previewConfig: {
    showPreview: false
  }
};
const EmojiPicker = (props) => {
  const { colorScheme } = useColorScheme();
  const { skinTone, setEmojiPickerSkinTone } = useEmojiSkinTone();
  return /* @__PURE__ */ jsx(StyledEmojiPickerLib, {
    ...defaultProps,
    ...props,
    defaultSkinTone: skinTone,
    onSkinToneChange: setEmojiPickerSkinTone,
    lazyLoadEmojis: true,
    theme: colorScheme === "system" ? Theme.AUTO : colorScheme === "dark" ? Theme.DARK : Theme.LIGHT
  });
};
const StyledEmojiPickerLib = styled(EmojiPicker$1).withConfig({
  displayName: "EmojiPicker__StyledEmojiPickerLib",
  componentId: "sc-3f68f6dd-0"
})([
  `&.epr-main.EmojiPickerReact{font-family:Inter,sans-serif;border:none;background:transparent;--epr-search-input-padding:0 2.125rem;--epr-search-border-color:`,
  `;--epr-category-label-padding:0 1rem;--epr-emoji-variation-picker-bg-color:transparent;--epr-category-label-bg-color:rgba(`,
  `,0.8);--epr-bg-color:transparent;--epr-hover-bg-color:transparent;--epr-hover-bg-color-reduced-opacity:transparent;--epr-active-bg-color:transparent;--epr-active-skin-tone-indicator-border-color:`,
  `;}& [aria-controls='epr-search-id'],[aria-controls='epr-search-id']:focus{background:`,
  `;color:`,
  `;border-color:`,
  `;font-weight:500;font-size:0.875rem;&::placeholder{color:`,
  `;}}&{.epr-emoji-category-label{color:`,
  `;font-weight:500;font-size:0.875rem;}}& .epr-skin-tones{background:transparent;}& button.epr-tone{&:focus{box-shadow:none;}&:after{border-radius:6px;}}`
], cssVar["color-app-primary"], cssVar["color-bg-secondary-rgb"], cssVar["color-text-tertiary"], cssVar["color-bg-tertiary"], cssVar["color-text-primary"], cssVar["color-border-primary"], cssVar["color-text-placeholder"], cssVar["color-text-placeholder"]);

export { EmojiPicker };
//# sourceMappingURL=EmojiPicker.js.map
